import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import DashboardCard from "./DashboardCard";
// import arr from "./dummy";
import LoadingSpinner from '../../components/LoadingSpinner'
import ReactTooltip from "react-tooltip";
import { Badge, Button, DialogContainer, Divider, SelectField } from "react-md";
import styles from '../../css/styles.css';
import PracticeSetDialog from "./components/practiceSetDialog";
// import PracticeSetDialog from "./components/practiceSetDialog";
import { NotificationManager, NotificationContainer } from 'react-notifications';
import moment from "moment";

const Dashboard = (props) => {
  /* 
          0 - For Current tab
          1 - For Up Next
          2 - Past
          3 - My Sets
      */
  // const tabs = ["Current", "Up Next", "Past", "All", "By Assignment", "My Sets"];
  const tabs = ["Current", "Up Next", "Past", "All"];
  let defaultTabs = [
    {
      groupName: "Assignments",
      tabs: [
        {
          index: 3,
          name: 'All',
          activityTypeID: 11,
        },
        {
          index: 0,
          name: 'Current',
          activityTypeID: 8,
        },
        {
          index: 1,
          name: 'Up Next',
          activityTypeID: 9,
        },
        {
          index: 2,
          name: 'Past',
          activityTypeID: 10,
        },
      ]
    },
    {
      groupName: "Analytics & Additional Practice",
      tabs: [
        {
          index: 4,
          name: 'By Assignment',
          activityTypeID: 1,
        },
        {
          index: 5,
          name: 'My Sets',
          activityTypeID: 2,
        },
      ]
    }
  ]

  // let allTabs = [];

  const [allTabs, setAllTabs] = useState([])



  const queryParams = new URLSearchParams(location.search);

  let quizID = queryParams.get('quizID');
  let tab = queryParams.get('tab');
  let courseID = queryParams.get('courseID');

  const [activeTabIndex, setActiveTabIndex] = useState(3);
  const [expandFirst, seExpanFirst] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const [filteredAssignments, setFilteredAssignment] = useState([]);
  const [currentTabAssignments, setCurrentTabAssignments] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paginatedVal, setPaginatedVal] = useState(0);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [count, setCount] = useState(0);
  const [practiceAssignment, setPracticeAssignment] = useState(null);
  const [showPracticeCreatedDialog, setShowPracticeCreatedDialog] = useState(false);


  const [showAnalytics, setShowAnalytics] = useState(false);

  const [leftSelectedAssignment, setLeftSelectedAssignment] = useState(null);

 /*  useEffect(() => {
    console.debug(" props.tabName",  props.tabName)
    if (props.tabName && currentTabAssignments && currentTabAssignments.length ) {

      let selectedAssign = null;

      if (props.selectedQuizID || leftSelectedAssignment?.quizID) {
        let index  = currentTabAssignments.findIndex(item => item.quizID === props.selectedQuizID || item.quizID === leftSelectedAssignment?.quizID)
        if (index < 0) return;
        console.debug("index===", index)
        console.debug("currentTabAssignments[index]", currentTabAssignments[index])
        
        selectedAssign = currentTabAssignments[index]
      } else {
        selectedAssign = currentTabAssignments[0]
      }

      console.debug("selectedAssign", selectedAssign)

      setLeftSelectedAssignment(selectedAssign)

      
    } else if (props.tabName === null || props.tabName === undefined) {
      setLeftSelectedAssignment(null)
    }
  }, [currentTabAssignments, props.tabName]) */

  useEffect(() => {
    if (props.tabName) {
      console.debug("current", currentTabAssignments);
      console.debug("props.selectedQuizID", props.selectedQuizID)
      if (currentTabAssignments && currentTabAssignments.length && leftSelectedAssignment === null) {
        let selectedAssign = currentTabAssignments[0];
        if (props.selectedQuizID) {
          let index  = currentTabAssignments.findIndex(item => item.quizID === props.selectedQuizID);
          if (index < 0) return;
          selectedAssign = currentTabAssignments[index];
        }
        setLeftSelectedAssignment({
          ...selectedAssign,
          expand: true,
          categories: selectedAssign?.categories?.map(cat => {
            return {
              ...cat,
              expand: true,
            }
          })
        });
      } else {
        let index  = currentTabAssignments.findIndex(item => item.quizID === props.selectedQuizID || item.quizID === leftSelectedAssignment?.quizID)
        if (index < 0) return;
        setLeftSelectedAssignment(currentTabAssignments[index])
      }
    }
  }, [currentTabAssignments, props.tabName])

  /* useEffect(() => {
    if (leftSelectedAssignment && leftSelectedAssignment?.courseID !== -1) {
      let logPayload = {
        toNomenclatureID: 0, // clicked
        quizID: leftSelectedAssignment.quizID,
        subjectID: leftSelectedAssignment?.subjectID,
        topicID: leftSelectedAssignment?.topicID,
        categoryID: 0,
        activityTypeID: leftSelectedAssignment?.courseID === -1 ? 2: 1 // 2-mysets, 1-By Assignment
      };
      console.debug("logPayload", logPayload)
      onAddActivityLog(logPayload)
      
    }
  }, [leftSelectedAssignment]) */

  useEffect(() => {
    console.debug("props.tabName", props.tabName)
    if (props.tabName === "byassignments") {
      setAllTabs([])
      setActiveTabIndex(4)
    } else if (props.tabName === "sets") {
      setAllTabs([])
      setActiveTabIndex(5)
    } else {
      setAllTabs([defaultTabs[0]])
      setActiveTabIndex(3)
    }
  }, [props.tabName])

  useEffect(() => {
    console.debug("activeTabIndexactiveTabIndex", activeTabIndex)
  }, [activeTabIndex])

  useEffect(() => {
    setLoading(true);
    fetchStudentAssignments();
  }, [props.selectedCourseID]);

  useEffect(() => {
    if (window.innerWidth <= 700 || checkIfMobile()) {
      setIsMobile(true);
    }
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      if (newWidth <= 700) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (quizID !== null && tab !== null && courseID) {
      setShowAnalytics(true);
      handleTabClick(parseInt(tab), parseInt(quizID));
      // setCurrentTabAssignments(getAssignmentsForTabIndex(parseInt(tab), parseInt(quizID)));
    } else {
      if (assignments) {
        if (props.tabName === "byassignments") {
          handleTabClick(4, -1);
        } else if (props.tabName === "sets") {
          handleTabClick(5, -1);
        } else {
          handleTabClick(activeTabIndex, -1);
        }

      }
      // setCurrentTabAssignments(assignments);
    }

    console.debug("assignments" ,assignments)

  }, [assignments])

  useEffect(() => {
    if (currentTabAssignments?.length) {
      scrollToTheQuiz();
    }

  }, [currentTabAssignments])

  const scrollToTheQuiz = () => {
    if (quizID !== null) {
      document.getElementById(`quiz_id_${quizID}`)?.scrollIntoView(true);
      window.scrollBy(0, -50);

      // Clear the query strings 
      setTimeout(() => {
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete("quizID");
        queryParams.delete("tab");
        queryParams.delete("courseID");
        const updatedSearchString = queryParams.toString();
        window.history.replaceState(null, '', `?${updatedSearchString}`);
      }, 1000);
    }
  }

  const getAssignmentsForTabIndex = (index, quizID) => {

    setPaginatedVal(0);
    console.debug("indexindex", index)
    setActiveTabIndex(index);
    setSelectedCategories([]);

    if (index === 3) { // "All" tab
      let allAssignments = assignments.filter(assign => assign.courseID !== -1)
      return allAssignments;
    }
    let newAssignments;
    if (index === 4) {
      newAssignments = assignments.filter(ele => ele.activeIndex !== 1 && ele.courseID != -1 && ele.isMasteryCompleted);
      let updatedAssignments = [];
      /* newAssignments.forEach((assignment, index) => {

        if (index === 0 || quizID === assignment.quizID) {
          // Update expand property of the first assignment
          updatedAssignments.push({
            ...assignment,
            expand: false,
            categories: assignment.categories?.map(category => ({
              ...category,
              expand: false
            }))
          });
         } else {
          updatedAssignments.push(assignment);
         };
      }); */
      return newAssignments;

    } else {
      newAssignments = assignments.filter(
        (assign) => assign.activeIndex === index
      )
    }


    return newAssignments;
  }

  const checkIfMobile = () => {
    return /Mobi|Android/i.test(window.navigator.userAgent);
  };

  const fetchStudentAssignments = () => {
    let responsePromise = props.apiService({
      method: "POST",
      url: "/getStudentDashboardAssignments",
      data: {
        course_id: props.selectedCourseID ? props.selectedCourseID : -1,
        tabName: props.tabName
      }
    });
    responsePromise
      .then((res) => {
        if (res && res.data && res.data.data) {
          //   res.data.data.map((ele) => {
          //     ele.attempted = true;
          //   });

          let newAssignments = res.data.data.filter(
            (assign) => assign.activeIndex === 0
          )

          const updatedAssignments = newAssignments.map((assignment, index) => {
            if (index === 0) {
              // Update expand property of the first assignment
              return {
                ...assignment,
                expand: true,
                categories: assignment?.categories?.map(category => ({
                  ...category,
                  expand: true
                }))
              };
            }
            return assignment;
          });
          // setCurrentTabAssignments(updatedAssignments);
          // setCurrentTabAssignments(res.data.data);
          setAssignments(res.data.data);
        } else {
          setAssignments([]);
        }
      })
      .catch((error) => {
        console.error("Error when getting Student Dashboard Data", error);
      })
      .finally(() => {
        setLoading(false);
        // getCorrespondingAssignmentsForTab(0);
      });
  };

  const getCorrespondingAssignmentsForTab = (tabIndex) => {

    setPaginatedVal(0);
    setActiveTabIndex(tabIndex);
    setSelectedCategories([]);

    /* 
      Tab - Current, Up Next, Past
      State - Start, Resume, Completed
    */
    let tabAssignments = [];

    const currentDate = moment();

    if (tabIndex === 0) { // Current
      // Get all current assignments and a 'state' property [Start, Resume, Completed]
      tabAssignments = assignments.filter(assignment => {
        const startDate = moment(assignment.startDate, 'DD/MM/YYYY');
        const endDate = moment(assignment.endDate, 'DD/MM/YYYY');
        return currentDate.isBetween(startDate, endDate, null, '[]') && assignment.isFinish !== 1;
      });
      tabAssignments = tabAssignments.map(tabAssignment => {
        return { ...tabAssignment, state: tabAssignment.isFinish === 0 ? "Start" : "Resume", tab: "Current", expandDisabled: true };
      })
    } else if (tabIndex === 1) { // Up Next
      tabAssignments = assignments.filter(assignment => {
        const startDate = moment(assignment.startDate, 'DD/MM/YYYY');
        return currentDate.isBefore(startDate);
      });
      tabAssignments = tabAssignments.map(tabAssignment => {
        return { ...tabAssignment, state: "Up Next", tab: "Up Next", expandDisabled: true };
      })
    } else if (tabIndex === 2) { // Past
      tabAssignments = assignments.filter(assignment => {
        const endDate = moment(assignment.endDate, 'DD/MM/YYYY');
        return assignment.isFinish === 1 || currentDate.isAfter(endDate);
      });
      tabAssignments = tabAssignments.map(tabAssignment => {
        return { ...tabAssignment, state: "Closed", tab: "Past", expandDisabled: true };
      })
    } else if (tabIndex === 3) { // All
      tabAssignments = assignments.map(assignment => {

      });
    }

    return tabAssignments
  }

  const onAddActivityLog = (payload) => {
    let response = props.apiService({
      method: "POST",
      url: "/addStudentActivityLog",
      data: payload
    });
    response.then(res => {
      console.debug("res", res)
    }).catch(err => {
      console.debug("err", err)
    }).finally(() => {
      setLoading(false);
    })
  }

  const handleTabClick = (index, quizID) => {
    // if (loading) return;
    // let tabAssignments = getCorrespondingAssignmentsForTab(index);
    // setCurrentTabAssignments(tabAssignments);
    // return

    const updatedAssignments = getAssignmentsForTabIndex(index, quizID);


    if (index === 4 || index === 5) {
      setShowAnalytics(true);
      if (updatedAssignments?.length > 0 && updatedAssignments[0]?.categories?.length > 0) {
        let showIndex = 0;
        if (quizID !== -1) {
          showIndex = updatedAssignments.findIndex(a => a.quizID === quizID);
          updatedAssignments[showIndex].expand = true;
          updatedAssignments[showIndex].categories[0].expand = true;
        }

        if (showIndex > -1 && !expandFirst) {
          if (updatedAssignments[showIndex]) {
            updatedAssignments[showIndex].expand = true;
          }

          if (updatedAssignments[showIndex].categories[0]) {
            updatedAssignments[showIndex].categories[0].expand = true;
          }
          seExpanFirst(true);
        }

      }
    } else {
      setShowAnalytics(false);
    }
    const stateOrder = { 'Start': 1, 'Resume': 2, 'Completed': 3, 'Up Next': 4, 'Closed': 5 };

    const sortedData = updatedAssignments.sort((a, b) => {
      const orderA = stateOrder[a.state];
      const orderB = stateOrder[b.state];

      if (orderA < orderB) return -1;
      if (orderA > orderB) return 1;
      return 0;
    });
    console.debug("sortedData", sortedData, updatedAssignments)
    setCurrentTabAssignments(sortedData);
  };

  const handleCategoryExpand = (assignQuizID, catIndex) => {

    let assignIndex = currentTabAssignments.findIndex(assign => assign.quizID === assignQuizID)
    console.debug("handleCategoryExpand assignIndex", assignIndex)
    if (assignIndex < 0) return;

    let newAssignments = [...currentTabAssignments];

    if (!newAssignments[assignIndex].categories[catIndex].attempted) return;

    let val = newAssignments[assignIndex].categories[catIndex].expand;
    newAssignments[assignIndex].categories[catIndex].expand = !val;
    setCurrentTabAssignments(newAssignments);

    const activityPayload = {
      toNomenclatureID: newAssignments[assignIndex].categories[catIndex].expand ? 1 : 2,
      quizID: newAssignments[assignIndex].quizID,
      subjectID: newAssignments[assignIndex].categories[catIndex].subjectID,
      topicID: newAssignments[assignIndex].categories[catIndex].topicID,
      categoryID: newAssignments[assignIndex].categories[catIndex].categoryID,
      activityTypeID: 4, // Time Clicked on "Category"
    }

    console.debug("activityPayload", activityPayload)

    onAddActivityLog(activityPayload)

  };

  const handleAssignmentExpand = (assignQuizID) => {

    let assignIndex = currentTabAssignments.findIndex(assign => assign.quizID === assignQuizID)
    console.debug("assignIndex", assignIndex)
    if (assignIndex < 0) return;
    let newAssignments = [...currentTabAssignments];

    let val = newAssignments[assignIndex].expand;
    newAssignments[assignIndex].expand = !val;

    newAssignments = newAssignments.map((assignment, index) => {
      if (index === assignIndex) {
        return {
          ...assignment,
          categories: assignment.categories?.map((category, catIndex) => ({
            ...category,
            expand: catIndex === 0 ? true : false
          }))
        }
      }
      return assignment
    })

    setCurrentTabAssignments(newAssignments);

    const activityPayload = {
      toNomenclatureID: newAssignments[assignIndex].expand ? 1 : 2,
      quizID: newAssignments[assignIndex].quizID,
      activityTypeID: 3, // Time Clicked on "Assignment"
    }

    console.debug("activityPayload", activityPayload)

    onAddActivityLog(activityPayload)
  };

  const checkIfCategoryIsSelected = (category) => {
    let selectedCatKey = `${category.subjectID}_${category.topicID}_${category.categoryID}`
    if (selectedCategories && selectedCategories.length) {
      return selectedCategories.some(cat => `${cat.subjectID}_${cat.topicID}_${cat.categoryID}` === selectedCatKey);
    }
    return false
  }

  const handleAddToPractice = (assignQuizID, catIndex, value) => {
    console.debug("currentTabAssignments" ,currentTabAssignments, assignQuizID)
    let assignIndex = currentTabAssignments.findIndex(assign => assign.quizID === assignQuizID);
    console.debug("assignIndex" ,assignIndex)
    if (assignIndex < 0) return;
    
    let newAssignments = [...currentTabAssignments];
    if (newAssignments.length === 0 || !newAssignments[assignIndex]?.categories[catIndex]?.attempted) return;

    let selectedCat = newAssignments[assignIndex].categories[catIndex]
    let selectedAssign = newAssignments[assignIndex]


    if (value && checkIfCategoryIsSelected(selectedCat)) {
      // TODO show toast that the category with this id's has been added already
      NotificationManager.warning('This category is already selected. Please select a different one.', "", 3000);
    } else {
      newAssignments[assignIndex].categories[catIndex].addToPractice = value;

      // Selected categories for creating new practice set
      var masteryCount = 3
      if (selectedAssign?.category_mastery_count !== "") {
        let catMastCountMap = JSON.parse(selectedAssign?.category_mastery_count)
        let catKey = `${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}`
        masteryCount = catMastCountMap[catKey]
      }

      selectedCat['masteryCount'] = masteryCount;
      let newSelectedCategories = [...selectedCategories]

      if (selectedCat.addToPractice) {
        newSelectedCategories.push(selectedCat)
      } else {
        let index = newSelectedCategories.findIndex(cat => cat.subjectID === selectedCat.subjectID && cat.topicID === selectedCat.topicID && cat.categoryID === selectedCat.categoryID)
        if (index >= 0) {
          newSelectedCategories.splice(index, 1);
        }
      }

      console.debug("newSelectedCategories", newSelectedCategories, selectedCat)
      setSelectedCategories(newSelectedCategories)
      setCurrentTabAssignments(newAssignments);

      let logPayload = {
        toNomenclatureID: value ? 5 : 6, // 5-checked, 6-unchecked
        quizID: 0,
        subjectID: selectedCat.subjectID,
        topicID: selectedCat.topicID,
        categoryID: selectedCat.categoryID,
        activityTypeID: 14, // "Category" activity in p&p page
      };
      onAddActivityLog(logPayload)
    }
  };

  const handleCategoryChartChange = (assignQuizID, catIndex) => {

    let assignIndex = currentTabAssignments?.findIndex(data => data.quizID === assignQuizID);
    if (assignIndex < 0) return;

    let newAssignments = [...currentTabAssignments]

    if (newAssignments.length === 0 || !newAssignments[assignIndex].categories[catIndex].attempted) return;

    let val = newAssignments[assignIndex].categories[catIndex].showAccuracy;
    newAssignments[assignIndex].categories[catIndex].showAccuracy = !val;

    setCurrentTabAssignments(newAssignments);
  }

  const handleCategoryChartTypeChange = (assignQuizID, catIndex) => {

    let assignIndex = currentTabAssignments?.findIndex(data => data.quizID === assignQuizID);
    if (assignIndex < 0) return;

    let newAssignments = [...currentTabAssignments]

    if (newAssignments.length === 0 || !newAssignments[assignIndex].categories[catIndex].attempted) return;

    let cat = newAssignments[assignIndex].categories[catIndex]
    let val = cat.showLineChart;
    newAssignments[assignIndex].categories[catIndex].showLineChart = !val;

    // activity log
    let payload = {
      activityTypeID: 7,
      quizID: newAssignments[assignIndex].quizID,
      subjectID: cat.subjectID,
      topicID: cat.topicID,
      categoryID: cat.categoryID,
      toNomenclatureID: val ? 4 : 3
    }
    console.debug("payload", payload)
    onAddActivityLog(payload)

    setCurrentTabAssignments(newAssignments);

   /*  onAddActivityLog({
      activityTypeID: 7, // Time Category chart changed
      commonID: newAssignments[assignIndex] ? newAssignments[assignIndex].quizID : 0,
      from: val ? 'History chart' : 'Current chart',
      to: val ? 'Current chart' : 'History chart',
    }) */
  }

  const handleTitlePaginationValue = (value) => {
    setPaginatedVal(value);
  }

  const handleCarmenAssignmentURL = (assignment) => {
    let hostName = window.location.hostname;
    let baseDomain = 'https://osu.instructure.com';
    if (hostName === 'osu.student.dev.stemfluency.com'){
      baseDomain = 'https://canvas.ontoborn.com'
    }
    if (assignment.ltiCourseID !== -1) {
      let carmenURL = `${baseDomain}/courses/${assignment.ltiCourseID}/assignments/${assignment.ltiLineID}`
      window.location.href = carmenURL;
    } else {
      NotificationManager.warning('Looks like quiz is not mapped with this assignment.\n\nPlease try to launch the assignment from Carmen.', 'Not Mapped', 5000);
    }
  }


  const handleTakeQuizURL = (assignment) => {

    let quizType;
    if (assignment.quizType !== undefined && assignment.quizType !== null) {
      quizType = assignment.quizType
    } else {
      quizType = assignment.quiz_type
    }

    let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_Id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${quizType}`
    
    props.handleRoute(url)
  }

  const handleCreatePracticeSet = () => {

    if (selectedCategories && selectedCategories.length) {
      setShowDialog(true);
      onAddActivityLog({
        activityTypeID: 16,
      })
    }
  }

  const handleCloseDialog = () => {
    setShowDialog(false);
  }

  const onCreatePracticeSet = (practiceSetName, checkedCategories) => {
    setLoading(true)
    let quizDetails = [];

    let quizCategoryMasertyCountMap = {}
    let quizCategoryIsRequiredMap = {}
    let quizCategoryPositionMap = {}

    checkedCategories?.forEach((selCat, index) => {
      let catKey = `${selCat.subjectID}_${selCat.topicID}_${selCat.categoryID}`
      let subCatKey = `${selCat.subjectID}_${selCat.topicID}_${selCat.categoryID}_${selCat.subCategoryID}`
      quizDetails.push({
        "subject_id": selCat.subjectID,
        "topic_id": selCat.topicID,
        "category_id": selCat.categoryID,
        "subcategory_id": selCat.subCategoryID,
        "index": subCatKey,
        "order": index + 1,
        "question_count": 10, // TODO
        "subcategory_name": selCat.subCategoryName,
        "category_name": selCat.name,
        "randomize_questions": selCat.randomize_questions,
        "random_subcategory_order": 1,
        "subcategory_weight": 1,
        "non_graded": 0,
        "category_mastery_count": 3, // set 3 as a default mastery count | selCat.masteryCount,
        "category_is_required": 1,
        "category_at_last": 0,
        "category_at_begining": 0
      })
      quizCategoryMasertyCountMap[catKey] = 3, // set 3 as a default mastery count | selCat.masteryCount,
        quizCategoryIsRequiredMap[catKey] = 1
      quizCategoryPositionMap[catKey] = {
        "category_at_last": 0,
        "category_at_begining": 0,
      }
    })


    let quizCategoryMasertyCountMapStr = JSON.stringify(quizCategoryMasertyCountMap)
    let quizCategoryIsRequiredMapStr = JSON.stringify(quizCategoryIsRequiredMap)
    let quizCategoryPositionMapStr = JSON.stringify(quizCategoryPositionMap)

    const startDate = moment().subtract(1, 'days');
    const endDate = moment().add(30, 'days');

    let payload = {
      quiz_name: practiceSetName,
      start_date: startDate.format('DD/MM/YYYY'),
      start_time: "00:00",
      end_date: endDate.format('DD/MM/YYYY'),
      end_time: "23:59",
      quiz_type: 0,
      mastery_condition: 3,
      mastery_units: selectedCategories?.length, // Total cats 
      maximum_attempted: 2,
      semester_id: 0,
      course_id: -1, // -1 or null
      section_Id: -1, // -1 or null
      quiz_details: quizDetails,
      quiz_id: 0,
      testTimerEnabled: 0,
      fullScoreIfAttempted: 0,
      fixedAbsoluteTimeEnabled: 0,
      randomize_categories: 1,
      sections_list: [],
      splash_screen: <p>{practiceSetName}</p>,
      alt_splash_screen: "",
      NoCQC: 1,
      lockoutN: 20,
      enableSurvey: false,
      category_number_of_questions: '{}',
      category_mastery_count: quizCategoryMasertyCountMapStr,
      category_nocqc: quizCategoryIsRequiredMapStr, // category_nocqc had key and value as quizCategoryIsRequiredMapStr
      random_subcategory_order: quizCategoryIsRequiredMapStr, // random_subcategory_order had key and value as quizCategoryIsRequiredMapStr
      category_is_required: quizCategoryIsRequiredMapStr,
      category_position: quizCategoryPositionMapStr,
      free_choice_count: 0,
      subsection_id: 0,
      enable_subsection: false,
      is_nongraded: 1,
      allow_practice: true
    }



    let responsePromise = props.apiService({
      method: "post",
      url: "/addQuiz",
      data: payload,
    });

    responsePromise.then(res => {
      console.log("res", res)
      if (res && res.data && res.data.data) {
        // handleTakeQuizURL(res.data.data);

        setShowDialog(false);
        setShowPracticeCreatedDialog(true);
        setPracticeAssignment(res.data.data);
      }

      setShowDialog(false);
      setLoading(false);
    })

  }

  const handleDeleteQuiz = (quizID) => {
    setLoading(true);
    let responsePromise = props.apiService({
      method: 'post',
      url: "/deleteQuiz",
      data: {
        quiz_id: quizID,
        course_id: -1,
      }
    })

    responsePromise.then(res => {
      if (res && res.data && res.data.data === "" && res.data.message === "" && res.data.status === 0) {
        const updatedAssignments = assignments.filter(obj => obj.quizID !== quizID)
        setAssignments(updatedAssignments)

        const updatedCurrentTabAssignments = currentTabAssignments.filter(obj => obj.quizID !== quizID)
        setCurrentTabAssignments(updatedCurrentTabAssignments)
        if (updatedCurrentTabAssignments && updatedCurrentTabAssignments.length) {
          setLeftSelectedAssignment(updatedCurrentTabAssignments[0])
        } else {
          setLeftSelectedAssignment(null)
        }

      } else {

      }
    })

    setLoading(false);
  }

  const handleSetGoal = (val, chartName, catKey, subCatKey, courseID, assignIndex, catIndex, practiceIndex, quizID) => {

    let newAssignments = [...assignments]

    let index = newAssignments.findIndex(ele => ele.quizID === quizID)

    console.debug("leftSelectedAssignment>>>>", leftSelectedAssignment)

    let subjectID = leftSelectedAssignment?.categories[catIndex]?.subjectID
    let topicID = leftSelectedAssignment?.categories[catIndex]?.topicID
    let categoryID = leftSelectedAssignment?.categories[catIndex]?.categoryID

    let goal = parseInt(val, 10)
    let payload = {
      catKey,
      subCatKey,
      subjectID,
      topicID,
      courseID,
      practiceCount: courseID === -1 ? practiceIndex + 1 : practiceIndex, // Increase practice count if this is a practice set
      quizID: leftSelectedAssignment.quizID,
      categoryID
    }

    if (chartName === "Accuracy Index") {
      payload.accuracyGoal = goal
    } else {
      payload.timeGoal = goal
    }

    for (let i = 0; i < newAssignments.length; i++) {

      if (newAssignments[i].quizID === quizID) {

        if (chartName === "Accuracy Index") {
          newAssignments[i].categories[catIndex].lastAccuracyGoal = goal;
        } else {
          newAssignments[i].categories[catIndex].lastTimeGoal = goal;
        }

        break
      }
    }


    const updatedNewAssignments = newAssignments.map((assignment, index) => {
      if (quizID === assignment.quizID) {
        // Update expand property of the first assignment
        return {
          ...assignment,
          expand: true,
          categories: assignment.categories?.map(category => ({
            ...category,
            showAccuracy: chartName === "Accuracy Index" ? true : false,
            expand: `${category.subjectID}_${category.topicID}_${category.categoryID}` === catKey
          }))
        };
      }
      return {
        expand: false,
        ...assignment,
        categories: assignment.categories?.map(category => ({
          ...category,
          showAccuracy: chartName === "Accuracy Index" ? true : false,
          expand: false
        }))
      };
    });

    console.debug("payload", payload)

    let newLeftSelectedAssignments = updatedNewAssignments.find(assign => assign.quizID === leftSelectedAssignment.quizID);
    setLeftSelectedAssignment({...newLeftSelectedAssignments});

    const responsePromise = props.apiService({
      method: 'post',
      url: '/addGoal',
      data: payload
    })

    responsePromise.then(res => {
      if (res && res.data) {
        let data = res.data
        if (data.message === "" && data.status == 0) {
          NotificationManager.success('The goal has been set successfully.', "", 3000);
          setAssignments(updatedNewAssignments);
        }
      }
    })

  }

  const handleTopicUpArrow = () => {
    let index = currentTabAssignments?.findIndex(assign => assign.quizID === leftSelectedAssignment?.quizID)
    if (index <= 0) return;
    let selectedIndex = (index - 1 + currentTabAssignments?.length) % currentTabAssignments?.length;

    setLeftSelectedAssignment(currentTabAssignments[selectedIndex])

    let assignment = currentTabAssignments[selectedIndex];

    if (assignment && assignment?.courseID !== -1) {
      let logPayload = {
        toNomenclatureID: 0, // clicked
        quizID: assignment.quizID,
        subjectID: assignment?.subjectID,
        topicID: assignment?.topicID,
        categoryID: 0,
        activityTypeID: assignment?.courseID === -1 ? 2: 1 // 2-mysets, 1-By Assignment
      };
      console.debug("logPayload", logPayload)
      onAddActivityLog(logPayload)
    }
    
  }


  const handleTopicDownArrow = () => {
    let index = currentTabAssignments?.findIndex(assign => assign.quizID === leftSelectedAssignment?.quizID)

    if (index < 0 || index >= currentTabAssignments?.length - 1) return;
    let selectedIndex = (index + 1) % currentTabAssignments?.length;

    setLeftSelectedAssignment(currentTabAssignments[selectedIndex])

    let assignment = currentTabAssignments[selectedIndex];

    if (assignment && assignment?.courseID !== -1) {
      let logPayload = {
        toNomenclatureID: 0, // clicked
        quizID: assignment.quizID,
        subjectID: assignment?.subjectID,
        topicID: assignment?.topicID,
        categoryID: 0,
        activityTypeID: assignment?.courseID === -1 ? 2: 1 // 2-mysets, 1-By Assignment
      };
      console.debug("logPayload", logPayload)
      onAddActivityLog(logPayload)
    }
  }

  const getEmptyMessagesForTabs = () => {
    let emptyText = "";

    switch (activeTabIndex) {
      case 0: // current
        emptyText = "Current"
        break;
      case 1: // upnext 
        emptyText = "upnext"
        break;
      case 2: // past
        emptyText = "past"
        break;
      case 3: // all
        emptyText = "all"
        break;
    
      default:
        break;
    }
    if (props.tabName) {

      emptyText = props.tabName === "byassignments" ? "Please come back after finishing an assignment to view your performance here." : <div className="d-flex justify-content-center flex-column align-items-center">
        No practice sets found.
        <div className="font-weight-normal text-black mt-4 text-align-left fontClass-20" style={{
          
        }}>
          <div className="mb-2">To create a practice set, follow the below steps:</div>
          <div>1. Go to the “By Assignment” or “By Topic” tab.</div>
          <div>2. Add one or more categories to practice</div>
          <div>3. Click on “Create practice set" button and create one.</div>
        </div>
      </div>;
    } else {
      emptyText = "No assignments found";
    }
    
    return emptyText
  }

  const actions = [];
  actions.push({
    secondary: true, children: 'Close', onClick: () => {
      setShowPracticeCreatedDialog(false)
    }
  });
  actions.push(<Button raised primary onClick={() => {
    handleTakeQuizURL(practiceAssignment);
  }}>Start Practice</Button>);

  const handleLeftSelectAssignment = (assignment) => {

    setLeftSelectedAssignment({...assignment})
    
    if (assignment && assignment.quizID) {
      let logPayload = {
        toNomenclatureID: 0, // clicked
        quizID: assignment.quizID,
        subjectID: assignment?.subjectID,
        topicID: assignment?.topicID,
        categoryID: 0,
        activityTypeID: assignment?.courseID === -1 ? 2: 1 // 2-mysets, 1-By Assignment
      };
      console.debug("logPayload", logPayload)
      onAddActivityLog(logPayload)
    }
    
  }

  return (
    <div
      className="dashboard-container"
      style={{
        scrollBehavior: "smooth"
      }}
    >
      <script src="https://cdn.jsdelivr.net/npm/chartjs-plugin-dragdata@2.2.3/dist/chartjs-plugin-dragdata.min.js"></script>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />

      {showPracticeCreatedDialog ? 
        <DialogContainer
          id="simple-action-dialog"
          visible={true}
          actions={actions}
          title="Your Practice Set Is Created!"
        >
          <div className="fontClass-14">Do you want to take it now? You can always access it later by selecting the "My Sets" Tab.</div>
        </DialogContainer>
      : null}

      {/* floating assignments */}
      {props.tabName && currentTabAssignments?.length ? 
        <div className="floating-container">
          <div className="arrow" onClick={handleTopicUpArrow}>
              <i class="fas fa-chevron-up"></i>
            </div>
          <div className="floating">
            {currentTabAssignments?.map((assign, index) => {
              return <div key={assign.quizID} className={`${leftSelectedAssignment?.quizID === assign.quizID ? "selected-assign" : ""}`}
                onClick={() => {
                  let assignment = {
                    ...assign,
                    expand: true,
                    categories: assign?.categories?.map(c => {
                      return {
                        ...c,
                        expand: true,
                      }
                    })
                  }
                  setLoading(true);
                  // setLeftSelectedAssignment(assignment);
                  handleLeftSelectAssignment(assignment);

                }}
                >
                {assign.quizName}
              </div>
            })}
          </div>
          <div className="arrow" onClick={handleTopicDownArrow}>
              <i class="fas fa-chevron-down"></i>
            </div>
        </div>
        : null}

      {/* Left side bar */}
      <div className="left-tab-container" style={{
        display: allTabs.length === 0 ? 'none' : 'block'
      }}>
        {allTabs?.map((allTab, index) => {
          {/* if (index === 0) return; */ }
          return <div className="left-tab-grp mb-3">
            {/* <h4>{"Assignments"}</h4>
            <SelectField
              id="selectCourses"
              className="md-cell md-cell--4  md-cell--6-phone DashBoardSelectFieldBigClass"
              style={{
                width: '90%',
              }}
              placeholder="Select"
              itemLabel="title"
              menuItems={allTabs[0].tabs.map((t) => {
                return {
                  key: 'KEY_' + t.index,
                  title: t.name,
                  value: t.index,
                }
              })}
              value={activeTabIndex}
              onChange={(index) => {
                handleTabClick(index, -1)
              }}
            />
            <Divider className="my-4" style={{
              width: '90%',
              height: "1px"
            }} /> */}
            <h4>{allTab.groupName}</h4>
            {allTab.tabs.map((tab) => {
              return (
                <>
                  <div
                    key={tab.index}
                    onClick={() => {
                      onAddActivityLog({
                        activityTypeID: tab.activityTypeID,
                      })
                      handleTabClick(tab.index, -1)
                    }}
                    className={`left-tab ${activeTabIndex === tab.index &&
                      "left-tab-active"
                      }`}
                  >
                    <span>{tab.name}</span>
                  </div>
                </>
              );
            })}
          </div>

        })}

        {/* <div className="left-tab-grp1">
            <h4>Assignments</h4>
              {tabs.map((tab, index) => {
                return (
                  <>
                    <div
                      key={index}
                      onClick={() => handleTabClick(index)}
                      className={`left-tab ${
                        activeTabIndex === index &&
                        "left-tab-active"
                      }`}
                    >
                      <span>{tab}</span>
                    </div>
                  </>
                );
              })}
            </div> */}

        {/*             <div className="left-tab-grp2">
            <h4>Analytics & Additional Practice</h4>
              {analyticTabs.map((tab) => {
                return (
                  <>
                    <div
                      key={tab.index}
                      onClick={() => handleTabClick(tab.index)}
                      className={`left-tab ${
                        activeTabIndex === tab.index &&
                        "left-tab-active"
                      }`}
                    >
                      <span>{tab.name}</span>
                    </div>
                  </>
                );
              })}
            </div> */}

      </div>

      <div className="w-100 d-flex justify-content-center">
        <div
          style={{
            width: "800px",
            marginBottom: "5rem"
          }}
        >

          {/* Mobile bottom navigation */}
          {props.tabName ? null : <div className="custom-tab-container">
            {tabs.map((tab, index) => {
              return (
                <div
                  key={index}
                  onClick={() => handleTabClick(index, -1)}
                  className={`custom-tab ${activeTabIndex === index &&
                    "custom-tab-active"
                    }`}
                >
                  <span>{tab}</span>
                </div>
              );
            })}
          </div>}

          <div className="mb-2 custom-sticky-container shadow-sm" style={{
            display: props.tabName ? 'none' : 'block'
          }}>
            <div style={{
              fontSize: "20px",
              fontWeight: "800",
              textAlign: "center",
              color: "#666666"

            }}>{tabs[activeTabIndex]} {activeTabIndex < 4 ? " Assignments" : ''}
              {/* ({paginatedVal === 0 && currentTabAssignments.length !== 0 ? 1 : paginatedVal} of {currentTabAssignments.length}) */}
            </div>
          </div>
          <div className="text-center font-weight-bold mt-4 fontClass-22" style={{color:"#bb0000"}}>
            { loading || currentTabAssignments?.length ? null : 
              getEmptyMessagesForTabs()
            }
          </div>

          {loading
            ? <LoadingSpinner />
            : <DashboardCard
              isMobile={isMobile}
              activeTabIndex={activeTabIndex}
              assignments={currentTabAssignments?.map(assign => {
                if (assign.quizID === leftSelectedAssignment?.quizID) {
                  return {
                    ...assign,
                    expand: true,
                    categories: assign.categories?.map(cat => {
                      return {...cat, expand: true}
                    })
                  }
                }
                return assign
              })}
              // assignments={currentTabAssignments}
              leftSelectedAssignment={leftSelectedAssignment}
              handleAssignmentExpand={() => {}}
              handleCategoryExpand={() => {}}
              handleAddToPractice={handleAddToPractice}
              handleCategoryChartChange={handleCategoryChartChange}
              handleCategoryChartTypeChange={handleCategoryChartTypeChange}
              handleTitlePaginationValue={handleTitlePaginationValue}
              handleTakeQuizURL={handleTakeQuizURL}
              handleCarmenAssignmentURL={handleCarmenAssignmentURL}
              handleDeleteQuiz={handleDeleteQuiz}
              handleSetGoal={handleSetGoal}
              showAnalytics={showAnalytics}
            />}
        </div>
      </div>

      {/* Floating Create New Practice Set button */}
      {activeTabIndex === 4 ?
        <>
          <ReactTooltip
            id={"create_new_practice_set"}
            multiline={true}
            place="bottom"
            effect="float"
          />

      <div className="assignment-set-btn" data-for={`create_new_practice_set`}
        data-tip={selectedCategories?.length > 0 ? null : "Please select atleast one category from any topics to create a practice set."}
        style={{
          backgroundColor: selectedCategories?.length ? '#bb0000' : '#808080'
        }}
        onClick={handleCreatePracticeSet}
        >
        Create Practice Set
        {selectedCategories?.length ? 
          <span className="floating-number">{selectedCategories?.length}</span>
        :  null}
        
      </div>
          {/* <div className="practice-set-btn-container">
            <Badge badgeContent={selectedCategories?.length} invisibleOnZero primary badgeId="selected-cat-count" badgeStyle={{
              backgroundColor: 'white',
              color: '#bb0000',
              fontWeight: "bold",
              border: '1px solid black',
              // left: 0,
              // top: -15,
              fontSize: "14px"
            }}>
              <div
                className="practice-set-btn shadow-sm"
                data-for={`create_new_practice_set`}
                data-tip={selectedCategories && selectedCategories.length > 0 ? null : "Please select atleast one category from any completed assignments to create a practice set."}
                onClick={handleCreatePracticeSet}
                style={{
                  backgroundColor: selectedCategories && selectedCategories.length ? '#bb0000' : '#808080'
                }}
              >
                Create New Practice Set
              </div>
            </Badge>


          </div> */}

        </>
        : null}

          {showDialog ? 
        <PracticeSetDialog
          showDialog={showDialog}
          selectedCategories={selectedCategories}
          handleCloseDialog={handleCloseDialog}
          onCreatePracticeSet={onCreatePracticeSet}
        />
      : null}
      <NotificationContainer />
    </div>
  );
};

export default Dashboard;
